export class FuseGenericError extends Error {
    constructor(message) {
        super(message);
    }
}
export class FuseErrorUtils {
    fuse_helper_validateRequiredNumber(keyValueValidates) {
        const errors = [];
        Object.entries(keyValueValidates).forEach(([key, value]) => {
            if (!(!isNaN(Number(value)) && typeof value === "number")) {
                errors.push(`${key} is required`);
            }
        });
        if (errors.length) {
            throw new FuseGenericError(`${errors.join("; ")}.`);
        }
    }
    fuse_helper_createFriendlyError(message, statusCode) {
        return new FuseGenericError(message);
    }
    fuse_helper_validateRequiredString(keyValueValidates) {
        const errors = [];
        Object.entries(keyValueValidates).forEach(([key, value]) => {
            if (!(value && typeof value === "string")) {
                errors.push(`${key} is required`);
            }
        });
        if (errors.length) {
            throw new FuseGenericError(`${errors.join("; ")}.`);
        }
    }
}
export const FuseErrorUtilsService = new FuseErrorUtils();
